import React from 'react';
import { vehicles } from '../data/article';
export function VehicleTable() {
  return <section aria-labelledby="vehicles-heading" className="mt-12" data-id="element-83" data-mp="35sd8oihj54en">
      <h2 id="vehicles-heading" className="font-serif text-[26px] font-bold leading-[1.25] tracking-[-0.01em] text-ink sm:text-[30px]" data-id="element-84" data-mp="35q0l9pt061u7">
        Vehicles Identified in the Court Order
      </h2>

      <table className="mt-7 w-full border-collapse text-left" data-id="element-85" data-mp="3tho21ewjvwir">
        <caption className="sr-only" data-id="element-86" data-mp="3tgwjb4o1xt9w">
          Vehicles identified in the November 1, 2025 court order
        </caption>
        <thead data-id="element-87" data-mp="3ogqoxgqedso4">
          <tr className="border-y border-rule-strong" data-id="element-88" data-mp="3jj8bpe5ckrab">
            <th scope="col" className="py-2 pr-4 font-sans text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-muted" data-id="element-89" data-mp="3jhnh5oj198cg">
              Make
            </th>
            <th scope="col" className="py-2 pr-4 font-sans text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-muted" data-id="element-90" data-mp="285mlrqrnylnq">
              Model
            </th>
            <th scope="col" className="py-2 text-right font-sans text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-muted" data-id="element-91" data-mp="1s33mclrb4rpf">
              Year
            </th>
          </tr>
        </thead>
        <tbody data-id="element-92" data-mp="1n5ajo2p7qftw">
          {vehicles.map(vehicle => <tr key={`${vehicle.make}-${vehicle.model}-${vehicle.year}`} className="border-b border-rule" data-id="element-93" data-mp="1n86ehi5rkoe4">
              <td className="py-3 pr-4 font-sans text-[14px] text-ink-muted" data-id="element-94" data-mp="19cuf2xgny9qv">{vehicle.make}</td>
              <td className="py-3 pr-4 font-sans text-[15px] font-medium text-ink" data-id="element-95" data-mp="1e78dl8qmgwzr">
                {vehicle.model}
              </td>
              <td className="py-3 text-right font-sans text-[14px] tabular-nums text-ink-muted" data-id="element-96" data-mp="14esu26zog0cr">
                {vehicle.year}
              </td>
            </tr>)}
        </tbody>
      </table>
    </section>;
}